// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const ProductListLoader = Loadable({
  loader: () => import('./ProductListContainer'),
  loading: Loader,
})

export default ProductListLoader
